var _path, _path2, _g, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#616161"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26:2683",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 11,
    width: 24,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57211 11.3447H31.3425V30.5013H8.57211V11.3447Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26:2683)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7452 11.3447H12.1674C10.1788 11.3447 8.57211 12.9636 8.57211 14.9548V23.5182C8.57211 25.5108 10.1788 27.1256 12.1674 27.1256H17.5335L19.3647 30.1064C19.3647 30.1064 19.3835 30.1427 19.4239 30.1925C19.5314 30.3767 19.7291 30.5017 19.9577 30.5017C20.1835 30.5017 20.3785 30.3767 20.4861 30.1965C20.5331 30.1427 20.5493 30.1064 20.5493 30.1064L22.3778 27.1256H27.7452C29.7311 27.1256 31.3432 25.5108 31.3432 23.5182V14.9548C31.3432 12.9636 29.7311 11.3447 27.7452 11.3447Z",
    fill: "#FAFAFA"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3209 20.6822C12.8261 20.6822 12.4254 20.2829 12.4254 19.7881C12.4254 19.292 12.8261 18.8926 13.3209 18.8926C13.8157 18.8926 14.2163 19.292 14.2163 19.7881C14.2163 20.2829 13.8157 20.6822 13.3209 20.6822ZM13.6288 17.6194C13.6288 17.6194 13.0063 17.6194 12.4416 18.1693V15.9575H11.05V21.7646H12.4577V21.3101C12.4577 21.3101 12.7898 21.9125 13.6288 21.9125C13.6288 21.9125 15.5918 21.8372 15.5918 19.7397C15.5918 19.7397 15.5205 17.6194 13.6288 17.6194Z",
    fill: "#616161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0416 15.8247V17.1706C16.0416 17.1706 16.6762 17.1424 16.6762 18.3282V21.7649H18.0207V18.0096C18.0207 18.0096 18.0785 15.8247 16.0416 15.8247Z",
    fill: "#616161"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3068 20.6822C20.8106 20.6822 20.4113 20.2829 20.4113 19.7881C20.4113 19.292 20.8106 18.8926 21.3068 18.8926C21.8016 18.8926 22.2022 19.292 22.2022 19.7881C22.2022 20.2829 21.8016 20.6822 21.3068 20.6822ZM21.3068 17.6382C21.3068 17.6382 19.0022 17.6382 19.0022 19.7881C19.0022 19.7881 18.9283 21.9125 21.3068 21.9125C21.3068 21.9125 23.6624 21.9084 23.6624 19.7881C23.6624 19.7881 23.7404 17.6382 21.3068 17.6382Z",
    fill: "#616161"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6756 20.6822C26.1809 20.6822 25.7788 20.2828 25.7788 19.788C25.7788 19.2919 26.1809 18.8926 26.6756 18.8926C27.1704 18.8926 27.5711 19.2919 27.5711 19.788C27.5711 20.2828 27.1704 20.6822 26.6756 20.6822ZM27.5093 17.7739V18.1692C27.5093 18.1692 27.1086 17.6381 26.3382 17.6381C26.3382 17.6381 24.3671 17.5534 24.3671 19.7732C24.3671 19.7732 24.3456 21.8425 26.283 21.8425C26.283 21.8425 27.0736 21.8721 27.5093 21.3101V21.6341C27.5093 21.6341 27.6074 22.6546 26.6205 22.6546H26.283V23.8889H26.8262C26.8262 23.8889 28.8632 23.9104 28.8632 21.7121V17.7739H27.5093Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.453775d809b89d89cc7c7ee11daf6d11.svg";
export { ForwardRef as ReactComponent };